import React, { useEffect } from "react";
import { GridStack } from "gridstack";
import GridItem from "../../../Components/UiComponents/GridItem/GridItem";
import DMSHeader from "../DMSHeader/DMSHeader";
import ContactTable from "./ContactTable/ContactTable";
import { useTranslation } from "react-i18next";

// Main Component for displaying contact details in table format
const ContactManagement = () => {
  const { t } = useTranslation(); // Initialize translation hook

  // Initialize GridStack
  useEffect(() => {
    GridStack.init();
  }, []);

  // Layout configuration for grid items with header and contact table component
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      // Header component with title, download and menu options
      component: (
        <DMSHeader
          title={t("contact_management_header")}
          showdownload={true}
          fileName="ContactManagement"
          showImportDropDownLabel={false}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 12,
      id: 2,
      component: <ContactTable />,
    },
  ];

  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} /> {/* Render grid-based layout */}
    </div>
  );
};

export default ContactManagement;
